import {
  EditButton,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const CountryShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="code" />
      <TextField source="heartbeatName" />
    </SimpleShowLayout>
  </Show>
);
